var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0767 2.21993C11.4183 1.39864 12.5817 1.39864 12.9233 2.21993L15.204 7.70329C15.348 8.04953 15.6736 8.28609 16.0474 8.31606L21.9671 8.79064C22.8538 8.86173 23.2133 9.96824 22.5378 10.5469L18.0276 14.4104C17.7428 14.6543 17.6184 15.0371 17.7054 15.4019L19.0833 21.1785C19.2897 22.0438 18.3485 22.7276 17.5894 22.264L12.5213 19.1684C12.2012 18.9729 11.7988 18.9729 11.4787 19.1684L6.41061 22.264C5.65152 22.7276 4.71026 22.0438 4.91665 21.1785L6.2946 15.4019C6.38161 15.0371 6.25723 14.6543 5.97245 14.4104L1.46222 10.5469C0.786685 9.96824 1.14621 8.86173 2.03286 8.79064L7.95261 8.31606C8.3264 8.28609 8.65201 8.04952 8.79602 7.70329L11.0767 2.21993Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsActive);
export default __webpack_public_path__ + "static/media/points-active.a4b1461fa0fb125e4b1f789c7eee1e68.svg";
export { ForwardRef as ReactComponent };